//localization
import * as json from '../lib/shared/localization/tr.json';
import * as richjson from '../lib/shared/localization/rich.tr.json';
// Dashboard Faz0 Clara: eski hâli — tek kullanıcısı dabnet-kamu app.component idi; json artık
// libs/raporlar/src/lib/services/dashboard-localization.ts içinden (lazy) import ediliyor
// import * as dashboardjson from '../lib/shared/localization/dx-dashboard.tr.json';
//constants
export * from '../lib/shared/constants/currency';
export const trMessages = json;
export const richTrMessages = richjson;
// Dashboard Faz0 Clara: eski hâli
// export const dashboardjsonTr = dashboardjson;
